import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/Input';
import { Textarea } from '@/components/ui/Textarea';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import type { StoreProfileFormData } from '@/lib/validators';

interface StoreBasicsFormProps {
  register: UseFormRegister<StoreProfileFormData>;
  errors: FieldErrors<StoreProfileFormData>;
}

export function StoreBasicsForm({ register, errors }: StoreBasicsFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Store Basics</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Input
          label="Store Name"
          {...register('name')}
          error={errors.name?.message}
          placeholder="e.g., Nike Store"
        />
        <Textarea
          label="Description (optional)"
          {...register('description')}
          error={errors.description?.message}
          placeholder="Tell customers about your store..."
          maxLength={500}
        />
      </CardContent>
    </Card>
  );
}
